export enum MyAppsEndPoints {
    GET_MY_APPS = 'GetMobileApps',
    GET_APP_LOGO = 'GetAppLogo',
    ARCHIVE_APP = 'TrashOrRestoreApplication',
    CREATE_MOBILE_BUILD = 'CreateMobileBuild',
    GET_BUILD_HISTORY = 'GetBuildHistory',
    GET_MOBILE_BUILD = 'GetMobileBuild',
    DOWNLOAD_MOBILE_PACKAGE = 'DownloadMobilePackage',
    GET_BUILD_REQUEST = 'GetBuildRequestByStatusOrBuildReqID',
    SHARE_LINK = 'SendMail',
    AUTHENTICATE = 'Authenticate'
}

export enum MyAppsQueryKey {
    GET_MY_APPS = 'GET_MY_APPS',
    GET_APP_LOGO = 'GET_APP_LOGO',
    ARCHIVE_APP = 'ARCHIVE_APPS',
    CREATE_MOBILE_BUILD = 'CREATE_MOBILE_BUILD',
    GET_BUILD_HISTORY = 'GET_BUILD_HISTORY',
    GET_MOBILE_BUILD = 'GET_MOBILE_BUILD',
    DOWNLOAD_MOBILE_PACKAGE = 'DOWNLOAD_MOBILE_PACKAGE',
    GET_BUILD_REQUEST = 'GET_BUILD_REQUEST',
    SHARE_LINK = 'SHARE_LINK',
    AUTHENTICATE = 'AUTHENTICATE'
}
